<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">With This Ring</h1>
<p class="author">Mignon G. Eberhart</p>
<div class="center">
<img alt="Images" src="images/logo3.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?1d2831c0